<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <nz-cascader [nzOptions]="nzOptions" [(ngModel)]="values" (ngModelChange)="onChanges($event)"></nz-cascader>
  &nbsp;
  <a href="javascript:;" (click)="changeNzOptions()" class="change-options">
    Change Options
  </a>
</div>